<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card min-h-[500px]">
      <form [formGroup]="form">
        <section class="min-h-7/12">         
          @if (step == 1 || step == 2) {
            <h1 class="section-heading mb-8">
              {{ "MEDIATION.HELLO" | translate : { name: loginUserName } }}
            </h1>
          }
          @if (step == 1) {
            <div class="relative bg-dc-navy/5 p-8 space-y-6 text-dc-navy text-center dc-card-stretch">
              <p class="text-xl! font-semibold! text-dc-navy! mb-6">
                {{ "MEDIATION.INTRO_TEXT" | translate }}
              </p>
              <div class="px-10 py-3">
                <app-button
                  [type]="'button'"
                  classesName="btn-edge-cut btn-width-auto"
                  [label]="'BUTTONS.BEGIN' | translate"
                  (onBtnClick)="step = 2"
                ></app-button>
              </div>
              <div class="dc-card-corner-blue"></div>
            </div>
          }

          <!-- question cards -->
          @if (step == 2) { 
          @for (q of questions; track q; let i = $index) {
          @if(i === currentQuestion) {
             <div class="relative bg-dc-navy/5 p-8 space-y-6 text-dc-navy dc-card-stretch">
              <!-- question text -->
              <h1 class="text-lg font-bold">
                {{ q.qKey | translate }}
              </h1>
              <div class="space-y-4 min-h-28">
                @for (opt of q.optKeys; track opt) {
                <label class="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    [formControlName]="q.key"
                    required="true"
                    [value]="opt.value"
                    (change)="onOptionSelect(q.key)"
                    class="h-5 w-5 text-dc-navy border-gray-300 accent-[#003366]"
                  />
                  <span class="">
                    {{ opt.label | translate }}
                  </span>
                </label>
                }
              </div>
              <!-- wizard nav -->
              <div class="flex justify-center gap-2 pt-4 select-none">
                <button
                  type="button"
                  (click)="prevQuestion()"
                  [disabled]="currentQuestion === 0"
                  class="px-3 py-1 text-dc-navy font-semibold disabled:opacity-50"
                >
                  <!-- <i
                    class="fas fa-angle-left px-2 transition-transform rtl:rotate-180"
                  ></i> -->
                  <img src="/icons/svg/previous.svg" class="px-2 transition-transform rtl:rotate-180">
                  <!-- {{ "PAGENATION.PRE" | translate }} -->
                </button>
                @for (page of questions; track page; let i = $index) {
                <span
                  class="text-sm py-2 cursor-pointer"
                  [ngClass]="{
                    'text-dc-navy font-semibold': currentQuestion === i,
                    'text-dc-gray-light': currentQuestion !== i
                  }"
                  (click)="currentQuestion = i"
                  >{{ i + 1 }}</span
                >
                }
                <button
                  type="button"
                  (click)="
                    currentQuestion === questions.length - 1
                      ? finish(q.key)
                      : nextQuestion(q.key)
                  "
                  class="px-3 py-1 text-dc-navy font-semibold disabled:opacity-50"
                >
                  <!-- {{ "PAGENATION.NEXT" | translate }} -->

                  
                  <img src="/icons/svg/next.svg" class="px-2 transition-transform rtl:rotate-180">
                  <!-- <i
                    class="fas fa-angle-right px-2 transition-transform rtl:rotate-180"
                  ></i> -->
                </button>
              </div>
              <div class="dc-card-corner-blue"></div>
          </div>
          } } }
        </section>
      </form>

      @if (step == 3) {
      <app-not-eligible [reason]="notEligibleReason"></app-not-eligible>
      } @if (step == 4) {
      <section>
        <div class="space-y-10">
          <div
            class="relative border border-dc-navy text-dc-navy font-semibold px-6 py-4"
          >
            <h1 class="text-xl">{{ eligibility.boxKey | translate }}</h1>
            <!-- corder green -->
            <div class="dc-card-corner-green"></div>
          </div>
          <!-- documentation requirements -->
          <h1 class="section-heading">
            {{ eligibility.docReqHeaderKey | translate }}
          </h1>
          <div class="px-3">
            <p class="text-sm mb-3">
              {{ "MEDIATION.DOC_REQ_SUB" | translate }}
            </p>
            <ul class="list-decimal list-inside text-sm text-dc-navy space-y-1">
              @for (item of eligibility.docRequirements; track item) {
              <li>
                {{ item | translate }}
              </li>
              }
            </ul>
          </div>
          <!-- additional documents -->
          <h1 class="section-heading">
            {{ eligibility.addDocHeaderKey | translate }}
          </h1>
          <div class="px-3">
            <ul class="list-decimal list-inside text-sm text-dc-navy space-y-1">
              @for (item of eligibility.addDocuments; track item) {
              <li>
                {{ item | translate }}
              </li>
              }
            </ul>
          </div>
          <!-- fees -->
          <h1 class="section-heading">
            {{ eligibility.feeHeaderKey | translate }}
          </h1>
          <div class="divide-y divide-gray-300 text-sm px-3">
            <table class="dc-table">
              <tbody>
                <tr>
                  <td colspan="2" class="font-semibold">
                    {{ "MEDIATION.MEMBERS" | translate }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>{{ "MEDIATION.REG_FEES" | translate }}</span>
                  </td>
                  <td>
                    <span
                      class="text-dc-navy"
                      [innerHTML]="
                        'MEDIATION.REG_FEE_MEM'
                          | translate : { amount: MedRegFeeMem | currency }
                      "
                    >
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>{{ "MEDIATION.ADMIN_FEES" | translate }}</span>
                  </td>
                  <td>
                    <span
                      class="text-dc-navy"
                      [innerHTML]="
                        'MEDIATION.ADMIN_FEE_MEM'
                          | translate
                            : {
                                percentValue: MedAdmFeeMemP,
                                minAdminFee: (MedAdmFeeMemMin | currency),
                                maxAdminFee: (MedAdmFeeMemMax | currency)
                              }
                      "
                    >
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="font-semibold">
                    {{ "MEDIATION.NON_MEMBERS" | translate }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>{{ "MEDIATION.REG_FEES" | translate }}</span>
                  </td>
                  <td>
                    <span
                      class="text-dc-navy"
                      [innerHTML]="
                        'MEDIATION.REG_FEE_NON'
                          | translate : { amount: MedRegFeeNonMem | currency }
                      "
                    ></span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>{{ "MEDIATION.ADMIN_FEES" | translate }}</span>
                  </td>
                  <td>
                    <span
                      class="text-dc-navy"
                      [innerHTML]="
                        'MEDIATION.ADMIN_FEE_NON'
                          | translate
                            : {
                                percentValue: MedAdmFeeNonMemP,
                                minAdminFee: (MedAdmFeeNonMemMin | currency),
                                maxAdminFee: (MedAdmFeeNonMemMax | currency)
                              }
                      "
                    >
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p
            class="font-semibold px-3 text-dc-black! border-b border-b-dc-black!"
          >
            {{ eligibility.noteKey | translate }}
          </p>

          <!-- agreement -->
          <div class="space-y-10 mt-7 px-3">
            <label
              class="flex items-center gap-5 lg:gap-x-2 cursor-pointer relative"
            >
              <input
                [(ngModel)]="agreeTermsAndCondition"
                name="agreeTerms"
                type="checkbox"
                class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
              />
              <span
                class="h-6 w-6 font-sans text-white text-sm text-center pt-0.25 absolute bg-white border border-dc-navy peer-checked:bg-dc-navy"
              >
                <i class="fas fa-check"></i>
              </span>
              <span class="text-sm text-dc-navy">
                {{ eligibility.agreeKey | translate }}
                <a
                  href=""
                  class="font-semibold underline text-dc-navy transition hover:text-dc-navy"
                  role="button"
                  (click)="openTermsModal($event)"
                >
                  {{ eligibility.termsKey | translate }}
                </a>
              </span>
            </label>
            @if( !agreeTermsAndCondition){
            <div class="fields-error-container">
              {{ "ACCEPT_TERMS_REQUIRED" | translate }}
            </div>
            }
            <!-- proceed button -->
          <app-button
            [type]="'button'"
            [label]="eligibility.btnKey | translate"
            (onBtnClick)="procedToFillApplication()"
          />
          </div>
          
        </div>
      </section>
      }

      <!-- comapy form -->
      @if (step >= 5) { @if(srDetailLoading){
      <app-skeleton-loader
        [formLoader]="true"
        [noOfFields]="8"
      ></app-skeleton-loader>
      } @else {
      <!-- Action for show notes -->
      @if (srNumber && srInprgoressAwating && !srDetailLoading) {
      <app-validation-message
        type="info"
        [content]="{
          title: 'SECTION_NOTES' | translate,
          message: 'SECTION_NOTES_DESCRIPTION' | translate
        }"
        [showbutton]="false"
        [buttonText]="'VIEW_NOTES' | translate"
        (onBtnClick)="showNotes = true"
      />
      }

      <app-defaulter-company-detail
        #companyDetailComp
        [form]="companyForm"
        [showActions]="showActions"
        (onSubmit)="submitData($event)"
        [currencyList]="currencyList"
        [srDetails]="srDetails"
        [defaulterCompany]="companyFormData"
        [folder]="srFolder"
        [mainFromSectionDocs]="mainFromSectionDocs"
        (onClickAddEditCompany)="openAddCompanyForm($event)"
        [currentStep]="this.step"
        [DCMember]="isDCMember"
      />

      @if(step >= 6){
      <section>
        <h2 class="section-heading">
          {{ "MEDIATION.FORM.UPLOAD_TITLE" | translate }}
        </h2>
        <div class="px-2 hidden">
          <p [innerHTML]="'DOCUMENT_NOTE' | translate"></p>
        </div>
        <div class="fields-container">
          @if(this.srFolder){ @for (dt of srFolder.allowedDocumentTypes; track
          $index) {
          <div class="field-control">
            <app-file
              #fileCmp
              [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
              [documentType]="dt.nameEn"
              (folderMissing)="openFolder()"
              (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
              [showAction]="showActions"
              [folder]="srFolder"
              [documentServiceType]="documentServiceType.MEDIATION"
              [stampLocationRequirement]="dt?.stampLocationRequirement || 'NOT_APPLICABLE'"
            ></app-file>
          </div>
          } }
        </div>
      </section>

      <!-- section for payment method -->
      <section>
          <h1 class="section-heading">
            {{ "SECTION_PAYMENT_METHOD" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-boolean
                [label]="'PAYMENT_METHOD' | translate"
                [control]="companyForm.get('paymentMethod')!"
                [lovType]="lookupKey.PAYMENT_METHOD"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
                (onSelectionChange)="onPaymentMethodChange($event)"
              />
            </div>
            @if ( noAdvancePaymentBalance) {
            <app-validation-message
              [content]="{
                title: 'ALERT.ERROR' | translate,
                message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate
              }"
              type="error"
            />
            }
          </div>
        </section>
      }

      @if(technicalErrorMsg){
        <app-validation-message
          [type]="'error'"
          [content]="{
            title: 'VALIDATION_MSG.ERROR' | translate,
            message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
          }"
          [showbutton]="false"
        ></app-validation-message>
        } 

      <!-- Error Message -->
      @if (errorMsg) {
      <app-validation-message
        [type]="'error'"
        [content]="{
          title: 'ALERT.ERROR' | translate,
          message: errorMsg
        }"
      >
      </app-validation-message>
      } 
      
      
      <div class="px-2 btn-section buttons-group">
        @if(showActions){
          @if(!formSubmitLoader){
          <app-button
            [type]="'button'"
            [label]="'BUTTONS.NEXT' | translate"
            classesName="btn-edge-cut  btn-width-auto"
            (onBtnClick)="nextStep()"
          />

          <app-button
            [type]="'button'"
            [label]="'BUTTONS.SAVE_CLOSE' | translate"
            classesName="card-edge-cut-white !btn-edge-cut btn-width-auto"
            (onBtnClick)="saveAndClose()"
          />
          }
        }
        @if(formSubmitLoader){
          <app-button
            [type]="'button'"
            [label]="'PLEASE_WAIT' | translate"
            classesName="btn-edge-cut  btn-width-auto"
            [disabled]="true"
          />
        }
        </div>
      } } 
    </div>
  </div>
</div>

<div>
  <app-service-progress
    [serviceName]="'MEDIATION.SERVICE_NAME' | translate"
    [completePercentage]="formProgress"
  />
</div>

@if (termsModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button class="modal-x-button" type="button" (click)="termsModal = false">
      <i class="fas fa-close"></i>
    </button>
    <h1
      class="section-heading ltr:text-left rtl:text-right text-2xl font-semibold text-dc-navy"
    >
      {{ eligibility.termsKey | translate }}
    </h1>
    <div
      class="mt-6 space-y-8 text-dc-navy pr-2"
      [attr.dir]="lang === 'ar' ? 'rtl' : 'ltr'"
    >
      <div>
        <p
          class="text-base font-semibold"
          [ngClass]="lang === 'ar' ? 'text-right' : 'text-left'"
        >
          {{ mediationTerms.prerequisitesHeading | translate }}
        </p>
        <ul
          class="mt-3 list-disc space-y-2 text-sm leading-relaxed text-dc-navy marker:text-dc-navy"
          [ngClass]="lang === 'ar' ? 'pr-6 text-right' : 'pl-6 text-left'"
        >
          @for (item of mediationTerms.prerequisites; track item) {
          <li class="text-sm leading-6">
            {{ item | translate }}
          </li>
          }
        </ul>
      </div>
      <div>
        <p
          class="text-base font-semibold"
          [ngClass]="lang === 'ar' ? 'text-right' : 'text-left'"
        >
          {{ mediationTerms.acknowledgementsHeading | translate }}
        </p>
        <ul
          class="mt-3 list-disc space-y-2 text-sm leading-relaxed text-dc-navy marker:text-dc-navy"
          [ngClass]="lang === 'ar' ? 'pr-6 text-right' : 'pl-6 text-left'"
        >
          @for (item of mediationTerms.acknowledgements; track item) {
          <li class="text-sm leading-6">
            {{ item | translate }}
          </li>
          }
        </ul>
      </div>
    </div>
    <div class="mt-8 flex justify-center">
      <app-button
        type="button"
        classesName="card-edge-cut-white btn-width-auto"
        [label]="'BUTTONS.CLOSE' | translate"
        (onBtnClick)="closeTermsModal()"
      >
      </app-button>
    </div>
  </div>
</div>
} @if (addCompanyModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button
      class="modal-x-button"
      type="button"
      (click)="addCompanyModal = false"
    >
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{ "MEDIATION.FORM.COMPANY_TITLE" | translate }}
    </h1>
    <!-- content -->
    <app-add-company
      [(isOpen)]="addCompanyModal"
      (onBtnClick)="submitCompanyDeatil($event)"
      [company]="companyDetail"
    />
  </div>
</div>
} @if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
}

<!-- notes modal -->
@if(showNotes) {
<app-notes
  [srNumber]="srNumber"
  [allowSubmit]="true"
  (onClose)="showNotes = false"
></app-notes>
}
